var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{staticStyle:{"background-color":"#F7F8FC"}},[_c('div',{staticClass:"container pb-0"},[_c('AppBar')],1),_c('DrawerDashboard'),_c('ViewDashboard')],1)}
var staticRenderFns = []

export { render, staticRenderFns }